var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 10C11.8359 10 11.5 10.3359 11.5 10.75V14.25C11.5 14.3877 11.3877 14.5 11.25 14.5H1.75C1.61231 14.5 1.5 14.3877 1.5 14.25V4.75C1.5 4.61231 1.61231 4.5 1.75 4.5H5.25C5.66406 4.5 6 4.16406 6 3.75C6 3.33594 5.66406 3 5.25 3H1.75C0.785156 3 0 3.78516 0 4.75V14.25C0 15.2148 0.785156 16 1.75 16H11.25C12.2148 16 13 15.2148 13 14.25V10.75C13 10.3359 12.6641 10 12.25 10ZM15.25 0H10C9.58594 0 9.25 0.335938 9.25 0.75C9.25 1.16406 9.58594 1.5 10 1.5H13.4394L5.71972 9.21972C5.42675 9.51269 5.42675 9.98731 5.71972 10.2803C5.86622 10.4267 6.05762 10.5 6.25 10.5C6.44238 10.5 6.63378 10.4267 6.78028 10.2803L14.5 2.56056V6C14.5 6.41406 14.8359 6.75 15.25 6.75C15.6641 6.75 16 6.41406 16 6V0.75C16 0.335938 15.6641 0 15.25 0Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAlt);
export default __webpack_public_path__ + "static/media/share-alt.93f78897.svg";
export { ForwardRef as ReactComponent };